export default function stripTags(str) {
  return str ? str.replace(/(<([^>]+)>)/gi, "") : "";
}
